import useCategoryFeedbackFormHandling from '../useCategoryFeedbackFormHandling';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useViewCareTeamApplicantInterviewAnswers } from './useViewCareTeamApplicantInterviewAnswers';
import { CategoryStep } from '../ApplicantInterviewWizard/CategoryStep';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthCareTeamStep = () => {
	const { application, dietaryHabitsAndHealth, setDietaryHabitsAndHealth } =
		useViewCareTeamApplicantInterviewAnswers();

	const { form, mandatoryQuestionsAndAnswersForm } =
		useCategoryFeedbackFormHandling(
			dietaryHabitsAndHealth,
			setDietaryHabitsAndHealth,
			true
		);

	return (
		<CategoryStep
			uiConfig={UiConfig}
			form={form}
			mandatoryQuestionsAndAnswersForm={mandatoryQuestionsAndAnswersForm}
			answers={application?.userAnswers}
			checkForCareTeamQuestions
		/>
	);
};
